import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { StorageService } from "@services/storage.service";

import { BehaviorSubject, Observable, map, tap } from "rxjs";
import { ExtendedApiResponse } from "./interfaces/api-status";
import { ISupportedTokens, ISupportedTokensResponse } from "./interfaces/supported-token";
import { environment } from "@env/environment";

@Injectable({
    providedIn: 'root',
  })
export class TokenService {
    readonly staticUrl = environment.staticUrl;

    protected storageKey = 'supportedTokens';

    protected supportedTokens$: BehaviorSubject<ISupportedTokens[]>;
    
    cachedSupportedTokens$: Observable<ISupportedTokens[]>;
    allCachedSupportedTokens$: Observable<ISupportedTokens[]>;
  
    constructor(
      private http: HttpClient,
      protected storage: StorageService,
    ) {
      this.supportedTokens$ = new BehaviorSubject<ISupportedTokens[]>(
        this.storage.get(this.storageKey, [])
      );
      this.cachedSupportedTokens$ = this.supportedTokens$.asObservable()
      .pipe(
          map((coins) => coins.filter((coin) => coin.is_active === 1))
      )
      this.allCachedSupportedTokens$ = this.supportedTokens$.asObservable();;
    }
  
    updateSupportedTokens(): Observable<
      ExtendedApiResponse<ISupportedTokensResponse>
    > {
  
      return this.http.post<ExtendedApiResponse<ISupportedTokensResponse>>('supported_tokens', {}).pipe(
        map((res: ExtendedApiResponse<ISupportedTokensResponse>) => {
          res.coin_list = res.coin_list.map(coin => ({
            ...coin,
            image: `${this.staticUrl}icons/${coin.logo_name}.svg`,
            precision_symbol: '0.' + '0'.repeat(coin.precision)
          }));
          return res
        }),
        tap((res: ExtendedApiResponse<ISupportedTokensResponse>) => {
          this.supportedTokens$.next(res.coin_list);
          this.storage.set(this.storageKey, res.coin_list);
        })
      );
    }


    getTokenRate(): Observable<string> {
      return this.http.post<any>('get_coindepo_rate', {});
    }
  
    getSupportedTokensSnapshot(): ISupportedTokens[] {
      return this.supportedTokens$.value;
    }
  
  
    getSupportedTokensByNameSnapshot(name: string): ISupportedTokens | undefined {
      return this.supportedTokens$.value.find((coin) => coin.coin_name === name);
    }
  
    getSupportedTokensByIdSnapshot(id: string | number): ISupportedTokens | undefined {
      return this.supportedTokens$.value.find((coin) => coin.coin_id === Number(id));
    }

    getSupportedCoinsByDescSnapshot(desc: string): ISupportedTokens {
      return this.supportedTokens$.value.find((coin) => coin.desc === desc) ?? this.supportedTokens$.value[0];
    }
}
